type FocusListener = () => void;

const listeners = new Set<FocusListener>();

const requestGlobalSearchFocus = (): void => {
	for (const listener of listeners) listener();
};

const subscribeGlobalSearchFocus = (listener: FocusListener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

const globalSearchFocus = {
	request: requestGlobalSearchFocus,
	subscribe: subscribeGlobalSearchFocus
};

export default globalSearchFocus;
